import { type Ref, type ReactNode, ChangeEvent } from 'react';
import { type InputAlign } from './InputContainer';
import { TextInputShared } from './TextInputShared';

interface Props {
  align?: InputAlign;
  end?: ReactNode;
  label: string;
  prefix?: string;
  suffix?: string;
  ref?: Ref<HTMLInputElement>;
  start?: ReactNode;
  step?: number;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onValue?: (value: string) => void;
  defaultValue?: string;
  min?: number;
  name?: string;
}

export function NumberInput(props: Props) {
  return <TextInputShared {...props} type="number" />;
}
